import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PTWDialog } from '../model/PTWDialog.model';

@Component({
  selector: 'ara-permit-dialog',
  templateUrl: './permit-dialog.component.html',
  styleUrls: ['./permit-dialog.component.css']
})
export class PermitDialogComponent implements OnInit {

  PTWPermitForm: FormGroup;
  IsHiddenB: boolean;
  IsHiddenC: boolean;
  isWithinFacilities: number;
  isHydrocarbonArea: number;
  isElectricalInstallations: number;
  isConfinedSpace: number;
  isSupplementaryCertificate: number;
  isEmergencyPlanning: number;
  isWorkForce: number;
  isCompetentStaff: number;
  isWrittenProcedure: number;
  PTWDialogModel: PTWDialog = new PTWDialog();
  btnLabel: string = "Apply Permit Job";

  @Output() parentFunction: EventEmitter<any> = new EventEmitter();

  constructor(private formBuilder: FormBuilder) { }

  submitDialog() {
    if (this.PTWPermitForm.valid) {
      this.PTWDialogModel.IsWithinFacilities = this.PTWPermitForm.get("IsWithinFacilities").value;
      this.PTWDialogModel.IsHydrocarbonArea = this.PTWPermitForm.get("IsHydrocarbonArea").value;
      this.PTWDialogModel.IsElectricalInstallations = this.PTWPermitForm.get("IsElectricalInstallations").value;
      this.PTWDialogModel.IsConfinedSpace = this.PTWPermitForm.get("IsConfinedSpace").value;
      this.PTWDialogModel.IsSupplementaryCertificate = this.PTWPermitForm.get("IsSupplementaryCertificate").value;
      this.PTWDialogModel.IsEmergencyPlanning = this.PTWPermitForm.get("IsEmergencyPlanning").value;
      this.PTWDialogModel.IsWorkForce = this.PTWPermitForm.get("IsWorkForce").value;
      this.PTWDialogModel.IsCompetentStaff = this.PTWPermitForm.get("IsCompetentStaff").value;
      this.PTWDialogModel.IsWrittenProcedure = this.PTWPermitForm.get("IsWrittenProcedure").value;
      this.PTWDialogModel.IsPlanWritten = this.PTWPermitForm.get("IsPlanWritten").value;
      this.PTWDialogModel.IsSupervisorAppointed = this.PTWPermitForm.get("IsSupervisorAppointed").value;
      this.parentFunction.emit(this.PTWDialogModel);
    }
  }

  checkTrueForA() {
    if (this.isWithinFacilities == 0 && this.isHydrocarbonArea == 0 && this.isElectricalInstallations == 0 &&
      this.isConfinedSpace == 0 && this.isSupplementaryCertificate == 0 && this.isEmergencyPlanning == 0) {
      this.IsHiddenB = false;
      this.PTWPermitForm.get("IsWorkForce").setValidators(Validators.required);
      this.PTWPermitForm.get("IsWorkForce").updateValueAndValidity();
      this.PTWPermitForm.get("IsCompetentStaff").setValidators(Validators.required);
      this.PTWPermitForm.get("IsCompetentStaff").updateValueAndValidity();
      this.PTWPermitForm.get("IsWrittenProcedure").setValidators(Validators.required);
      this.PTWPermitForm.get("IsWrittenProcedure").updateValueAndValidity();
    } else {
      this.PTWPermitForm.get("IsWorkForce").clearValidators(); // .setValidators(Validators.required);
      this.PTWPermitForm.get("IsWorkForce").updateValueAndValidity();
      this.PTWPermitForm.get("IsCompetentStaff").clearValidators();
      this.PTWPermitForm.get("IsCompetentStaff").updateValueAndValidity();
      this.PTWPermitForm.get("IsWrittenProcedure").clearValidators();
      this.PTWPermitForm.get("IsWrittenProcedure").updateValueAndValidity();

      this.PTWPermitForm.patchValue({
        IsWorkForce: '',
        IsCompetentStaff: '',
        IsWrittenProcedure: ''
      });

      this.IsHiddenB = true;
    }
  }

  checkFalseForB() {
    if (this.isWorkForce == 1 && this.isCompetentStaff == 1 && this.isWrittenProcedure == 1) {
      this.IsHiddenC = false;
      this.PTWPermitForm.get("IsPlanWritten").setValidators(Validators.required);
      this.PTWPermitForm.get("IsPlanWritten").updateValueAndValidity();
      this.PTWPermitForm.get("IsSupervisorAppointed").setValidators(Validators.required);
      this.PTWPermitForm.get("IsSupervisorAppointed").updateValueAndValidity();
    } else {
      this.PTWPermitForm.get("IsPlanWritten").clearValidators();
      this.PTWPermitForm.get("IsPlanWritten").updateValueAndValidity();
      this.PTWPermitForm.get("IsSupervisorAppointed").clearValidators();
      this.PTWPermitForm.get("IsSupervisorAppointed").updateValueAndValidity();

      this.PTWPermitForm.patchValue({
        IsPlanWritten: '',
        IsSupervisorAppointed: ''
      });

      this.IsHiddenC = true;
    }
  }

  decideButtonText(){
    this.btnLabel = this.PTWPermitForm.get("IsSupervisorAppointed").value == "true" && this.PTWPermitForm.get("IsPlanWritten").value == "true" ? "Apply No Permit Job" : "Apply Permit Job";
  }

  ngOnInit(): void {
    this.PTWPermitForm = this.formBuilder.group({
      IsWithinFacilities: new FormControl({ value: '', disabled: false }, Validators.required),
      IsHydrocarbonArea: new FormControl({ value: '', disabled: false }, Validators.required),
      IsElectricalInstallations: new FormControl({ value: '', disabled: false }, Validators.required),
      IsConfinedSpace: new FormControl({ value: '', disabled: false }, Validators.required),
      IsSupplementaryCertificate: new FormControl({ value: '', disabled: false }, Validators.required),
      IsEmergencyPlanning: new FormControl({ value: '', disabled: false }, Validators.required),
      IsWorkForce: new FormControl(),
      IsCompetentStaff: new FormControl(),
      IsWrittenProcedure: new FormControl(),
      IsPlanWritten: new FormControl(),
      IsSupervisorAppointed: new FormControl()
    });
    this.IsHiddenB = true;
    this.IsHiddenC = true;
  }
}
